@if (masked && maskedValue) {
  <div class="input-group reporter-date-masked">
    <input type="text"
           class="form-control"
           [value]="maskedValue"
           (focus)="maskedFocus($event)"
           (input)="unmask()">
    <div class="input-group-append">
      <button class="btn btn-action" type="button" (click)="unmask()">
        <reporter-icon icon="Calendar"></reporter-icon>
      </button>
    </div>
  </div>
} @else {
  <ejs-datepicker
    #sfPicker
    [enableMask]="true"
    [maskPlaceholder]="maskPlaceholder"
    [max]="futureOk && !maxDate ? null : effectiveMaxDate"
    [min]="effectiveMinDate"
    [value]="sfValue"
    [strictMode]="false"
    [openOnFocus]="true"
    [showClearButton]="false"
    [cssClass]="'reporter-sf-datepicker' + (required ? ' reporter-sf-datepicker--required' : '')"
    (change)="onSfChange($any($event))"
    (blur)="onTouched()">
  </ejs-datepicker>
}
